<div class="input-group representante-multiselect">
    <div class="input-group-prepend">
        <button class="btn btn-light" type="button" data-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-cog"></i>
        </button>
        <div class="dropdown-menu">
            <h6 class="dropdown-header">Situação</h6>
            <div class="dropdown-item" onclick="event.stopPropagation()">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [ngModel]="somenteAtivos" (ngModelChange)="toggleSomenteAtivos($event)" name="multiselectRepresentantesSomenteAtivos" id="multiselectRepresentantesSomenteAtivos">
                    <label class="custom-control-label" for="multiselectRepresentantesSomenteAtivos"> Somente Ativos</label>
                </div>
            </div>

            <ng-template [ngIf]="showModalidadesComerciais">
                <h6 class="dropdown-header">Modalidades Comerciais</h6>
                <div class="dropdown-item" onclick="event.stopPropagation()" *ngFor="let modalidadeChecker of modalidadesComerciaisCheckers">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="modalidadeChecker.isChecked" (ngModelChange)="onChangeModalidadeComercialChecker()" name="modalidadeChecker_{{modalidadeChecker.value.id}}" id="modalidadeChecker_{{modalidadeChecker.value.id}}">
                        <label class="custom-control-label" for="modalidadeChecker_{{modalidadeChecker.value.id}}">
                            {{modalidadeChecker.value.nome}}
                        </label>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <ngx-bootstrap-multiselect
        [settings]="settings"
        [texts]="texts"
        [options]="options"
        [(ngModel)]="idsRepresentantes"
        (ngModelChange)="onChange()"
        [disabled]="disabled">
    </ngx-bootstrap-multiselect>
</div>
